export default __webpack_public_path__ + "static/media/GB-SCT.1b4d681d.svg";